import React from 'react'
import { Text, Loader } from '@usap/uicomponents'

const DetailsLoader = ({ loading }) => (
  <>
    {loading && <Loader />}
    <Text size="small" margin={{ bottom: '20px' }}>
      Loading...
    </Text>
  </>
)

export default DetailsLoader
